var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'ban'],"size":"lg"}}),_vm._v(" You are not authorized to access this page. ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }